module.exports = __webpack_public_path__ + "static/media/sort-arrow-DESC.e1be002d.svg";